import { render, staticRenderFns } from "./TakipDetailDialog.vue?vue&type=template&id=11b0cbfe&scoped=true"
import script from "./TakipDetailDialog.vue?vue&type=script&lang=ts"
export * from "./TakipDetailDialog.vue?vue&type=script&lang=ts"
import style0 from "./TakipDetailDialog.vue?vue&type=style&index=0&id=11b0cbfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b0cbfe",
  null
  
)

export default component.exports